import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import Navbar from '@/components/feature/Navbar';
import LocalBusinessSchema from '@/components/LocalBusinessSchema';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import BrandsSection from './components/BrandsSection';
import ProductsGallery from './components/ProductsGallery';
import FinanceSection from './components/FinanceSection';
import GoogleReviewsSection from './components/GoogleReviewsSection';
import StoreGallerySection from './components/StoreGallerySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import MarketingPopup from './components/MarketingPopup';

export default function Home() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <LocalBusinessSchema />
      <main className="relative">
        <MarketingPopup />
        <Navbar />
        <HeroSection />
        <AboutSection />
        <StoreGallerySection />
        <ServicesSection />
        <StatsSection />
        <BrandsSection />
        <ProductsGallery />
        <FinanceSection />
        <GoogleReviewsSection />
        <ContactSection />
        <Footer />

        {/* WhatsApp Chat Button */}
        <motion.a
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1.5, duration: 0.5 }}
          href="https://wa.me/+919964111963"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="fixed bottom-20 right-6 z-50 w-14 h-14 flex items-center justify-center bg-emerald-500 hover:bg-emerald-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
          aria-label="Chat on WhatsApp"
          title="Chat on WhatsApp"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </motion.a>

        <AnimatePresence>
          {showScrollTop && (
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              onClick={scrollToTop}
              className="fixed bottom-6 right-6 z-50 w-11 h-11 flex items-center justify-center bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full shadow-md transition-colors cursor-pointer"
              aria-label="Scroll to top"
            >
              <i className="ri-arrow-up-line text-lg"></i>
            </motion.button>
          )}
        </AnimatePresence>
      </main>
    </>
  );
}